export default {
  LIST: {
    TITLE: `Liste des jours fériés`,
    SUMMARY: ``
  },
  DELETE_BUTTON: {
    TITLE: `Supprimer le jour férié`,
    SUMMARY: `Êtes-vous certain de vouloir supprimer ce jour férié ?`,
    PRIMARY_ACTION: `Supprimer le jour férié`
  },

  CREATE: `Ajouter un jour férié`,
  form: {
    CREATE: {
      TITLE: `Création d'un jour férié`
    },
    EDIT: {
      TITLE: `Modification d'un jour férié`
    },
    NAME: {
      LABEL: `Nom du jour férié`,
      PLACEHOLDER: `Entrez un nom pour le jour férié.`,
      DESCRIPTION: ``
    },
    DATE: {
      LABEL: `Date`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Choisissez la date du jour férié.`
    },
    REGIONALTAGS: {
      LABEL: `Région`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Sélectionnez la région pour laquelle le jour férié est applicable.`
    },
    NAME_REQUIRED: `Le nom du jour férié est requis.`,
    DATE_REQUIRED: `La date du jour férié est requise.`
  }
}
